/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Header.css";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../images/logo.png";
import SearchBar from "../SearchBar";
import {
  FaInstagram,
  FaFacebookF,
  FaEnvelope,
  FaPhoneAlt ,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";
export default function Header({ navigateWithTransition }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [navLeft, setNavLeft] = useState(null);
  const navRef = useRef(null);
  const location = useLocation();

  const isParentActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

const getHeaderClass = () => {
  if ((location.pathname.startsWith("/collections/cuisines/"))||(location.pathname.startsWith("/collections/dressings/"))
  ||(location.pathname.startsWith("/export/projets-international/")))
    return "header transparent";

  if (location.pathname.startsWith("/sav"))
    return "header black";

  if (location.pathname === "/")
    return "header transparent";

  return "header default";
};

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  // Mesure la position gauche du menu desktop (Elements Group / Collections / SAV / Export)
  // pour que les 4 liens secondaires (CONTACTS, CUISINES, COMPANY, CATALOGUE)
  // tombent exactement sous leur équivalent. Déclaré après l'effet overflow :
  // la mesure se fait une fois la scrollbar masquée.
  useEffect(() => {
    const measure = () => {
      const nav = navRef.current;
      const ul = nav && nav.querySelector("ul");
      if (!ul || window.getComputedStyle(nav).display === "none") {
        setNavLeft(null); // tablette / mobile : pas d'alignement
        return;
      }
      setNavLeft(ul.getBoundingClientRect().left);
    };

    measure();
    const raf = requestAnimationFrame(measure);
    window.addEventListener("resize", measure);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", measure);
    };
  }, [open, location.pathname]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigate = (path) => {
    navigateWithTransition(path);
    setOpen(false);
  };

  // href réel (crawlable par Google) + navigation animée côté client
  const navProps = (path) => ({
    href: path,
    onClick: (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // nouvel onglet
      e.preventDefault();
      handleNavigate(path);
    },
  });
  // Le <title> de chaque page est géré par le composant SEO (react-helmet-async)
  return (
    <header className={`${getHeaderClass()} ${scrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <a {...navProps("/")} className="logo-link">
          <img src={logo} alt="Elements Group – cuisines sur mesure" className="logo" />
        </a>

        <div className="header-right">
          <nav className="nav desktop-nav" ref={navRef}>
            <ul>
              <li>
                <a
                  {...navProps("/elements/histoire")}
                  className={isParentActive("/elements") ? "nav-link active" : "nav-link"}
                >
                  Elements Group
                </a>
              </li>

              <li>
                <a
                  {...navProps("/collections/cuisines")}
                  className={isParentActive("/collections") ? "nav-link active" : "nav-link"}
                >
                  Collections
                </a>
              </li>

              <li>
                <a
                  {...navProps("/sav/garantie")}
                  className={isParentActive("/sav") ? "nav-link active" : "nav-link"}
                >
                  SAV & Garantie
                </a>
              </li>

              <li>
                <a
                  {...navProps("/export/projets-international")}
                  className={isParentActive("/export") ? "nav-link active" : "nav-link"}
                >
                  Export
                </a>
              </li>
            </ul>
          </nav>

          <SearchBar navigateWithTransition={navigateWithTransition} />

          <div
            className="burger"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={open}
            role="button"
            tabIndex={0}
          >
            {open ? <CloseIcon /> : <MenuIcon />}
          </div>
        </div>
      </div>

      <div className={open ? "menu-area active" : "menu-area"}>
        <div className="menu-overlay" onClick={() => setOpen(false)}></div>

        <div
          className="menu-panel"
          style={navLeft !== null ? { "--nav-left": `${navLeft}px` } : undefined}
        >
          <div className="drawer-primary-links">
            <a
              {...navProps("/elements/histoire")}
              className={isParentActive("/elements") ? "active" : ""}
              style={{ "--i": 1 }}
            >
              Elements Group
            </a>

            <a
              {...navProps("/collections/cuisines")}
              className={isParentActive("/collections") ? "active" : ""}
              style={{ "--i": 2 }}
            >
              Collections
            </a>

            <a
              {...navProps("/sav/garantie")}
              className={isParentActive("/sav") ? "active" : ""}
              style={{ "--i": 3 }}
            >
              SAV & Garantie
            </a>

            <a
              {...navProps("/export/projets-international")}
              className={isParentActive("/export") ? "active" : ""}
              style={{ "--i": 4 }}
            >
              Export
            </a>
          </div>

          <div className="drawer-secondary-links">
            <span  style={{ "--i": 5 }}><a className="drawer-secondary-link" href="/contact" target="_blank" rel="noopener noreferrer">CONTACTS</a></span>
            <span style={{ "--i": 6 }}><a className="drawer-secondary-link" href="/collections/cuisines">Cuisines</a></span>
            <span style={{ "--i": 7 }}><a className="drawer-secondary-link" href="/elements/histoire">COMPANY</a></span>
            <span style={{ "--i": 8 }}><a className="drawer-secondary-link" href="https://firebasestorage.googleapis.com/v0/b/elements-590a4.firebasestorage.app/o/Catalogue%20Elements_260408_164638%20(1).pdf?alt=media&token=f202712a-acba-49c9-9bc6-27aa226fae81">CATALOGUE</a></span>
          </div>

          <div className="social-links">
             <span style={{ "--i": 9 }}>Follow us :</span>
            <div className="footer-socials">
             
                        <a style={{ "--i": 10 }} href="https://www.instagram.com/elements.tunisie?igsh=N3Y2MnB4aDVjeHUy" aria-label="Instagram"><FaInstagram /></a>
                        <a style={{ "--i": 11 }} href="https://www.facebook.com/Elementstn" aria-label="Facebook"><FaFacebookF /></a>
                        <a style={{ "--i": 12 }} href="#" aria-label="YouTube"><FaYoutube /></a>
                        <a style={{ "--i": 13 }} href="https://www.linkedin.com/company/elements-tunisie/" aria-label="LinkedIn"><FaLinkedinIn /></a>
                      </div>
          </div>
           <div className="social-links">
             <span style={{ "--i": 14 }}>Contact us :</span>
            <div className="header-socials2">
                         <a style={{ "--i": 15 }} href="mailto:Mtr@elements.tn" aria-label="Mail"><FaEnvelope />&nbsp;Mtr@elements.tn</a>
                          <a style={{ "--i": 16 }} href="tel:33633809555" aria-label="Phone"><FaPhoneAlt  />&nbsp;+33 6 33 80 95 55</a>
                           <a style={{ "--i": 17 }} href="tel:21624870001" aria-label="Phone"><FaPhoneAlt  />&nbsp;+216 24 870 001</a>
                      </div>
          </div>
        </div>
      </div>
    </header>
  );
}